/**
 * Picks what to load from an image's renditions (media service, HCIT-1105). Renditions come smallest
 * first with `original` last, each {name, contentType, width, height, size, url}; only types a browser
 * can show are picked (a HEIC original never is).
 */
const BROWSER_TYPES = ["image/jpeg", "image/png", "image/gif", "image/webp", "application/pdf"];

/**
 * @param renditions the image's renditions
 * @param purpose "thumb" (small preview), "view" (normal view) or "full" (largest a browser shows)
 * @returns the rendition, or null if none can be shown
 */
export function pickRendition (renditions, purpose) {
    const viewable = (renditions || []).filter(r => BROWSER_TYPES.includes(r.contentType));
    if (viewable.length === 0) {
        return null;
    }

    const named = (name) => viewable.find(r => r.name === name);
    const largest = viewable[viewable.length - 1];
    switch (purpose) {
        case "thumb":
            return named("thumb") || viewable[0];
        case "full":
            return largest;
        default:
            return named("display") || largest;
    }
}
